function r(e) {
  return e === void 0 && (e = ""), `.${e.trim().replace(/([\.:!+\/])/g, "\\$1").replace(/ /g, ".")}`;
}
export {
  r as c
};
//# sourceMappingURL=classes-to-selector.mjs.map
